import React from "react";
import Navbar from "../../components/companyLandingComponents/Navbar/Navbar";
import HeroSection from "../../components/companyLandingComponents/HeroSection/HeroSection";
import InfoSection from "../../components/companyLandingComponents/InfoSection/InfoSection";
import GlobalAgencyHero from "../../components/companyLandingComponents/GlobalAgencyHero/GlobalAgencyHero";
import HowItWorks from "../../components/companyLandingComponents/HowItWorks/HowItWorks";
import SisterConcern from "../../components/companyLandingComponents/SisterConcern/SisterConcern";
import FooterSection from "../../components/Footer/Footer";
import AllCompanyCard from "../../components/companyLandingComponents/AllCompanyInfo/AllCompanyCard";
import OurProducts from "../../components/OurProducts/OurProducts";
import OurServices from "../../components/OurServices/OurServices";
import OurProjects from "../../components/OurProjects/OurProjects";

const CompanyLandingPage = () => {
  return (
    <div>
      <Navbar></Navbar>
      <HeroSection></HeroSection>
      <InfoSection></InfoSection>
      <GlobalAgencyHero></GlobalAgencyHero>
      <AllCompanyCard></AllCompanyCard>
      <OurProducts></OurProducts>
      <OurProjects></OurProjects>
      <OurServices></OurServices>
      <HowItWorks></HowItWorks>
      <SisterConcern></SisterConcern>
      <FooterSection></FooterSection>
    </div>
  );
};

export default CompanyLandingPage;
